import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import EditItemComp  from "./Component/EditItemComp"

const EditItem =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <EditItemComp />
        </div>
        <Footer />
        </>
    )
}

export default EditItem